import axiosInst from '../../libs/axios/axios'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  addOrEdit: false,
  noteActions: [],
  note:null
}
const getters = {
  noteAddOrEdit (state) {
    return state.addOrEdit
  },
  returnNoteActions (state) {
    return state.noteActions
  },
  noteData (state) {
    return state.note
  }
}
const mutations = {
  addOrEdit (state) {
    state.addOrEdit = !state.addOrEdit
  },
  noteActions (state, info) {
    state.noteActions = info
  },
  note (state, info) {
    state.note = info
  }
}
const actions = {
  noteAddOrEdit (store) {
    store.commit('addOrEdit')
  },
  getHiveNotesList (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/notes/${  info}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getHiveNoteData (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/notes/${  info}`)
        .then(response => {
          store.commit('note', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getHiveNoteTypes () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/notes/types/`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getHiveNoteActions (store) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/notes/actions/`)
        .then(response => {
          const data = {}
          const noteActions = []
          response.data.map((value, index) => {
            if (value.header === null) {
              if (!Object.prototype.hasOwnProperty.call(data, value.id)) {
                data[value.id] = [{ code: 'header', label: value.name }]
              } else {
                data[value.id].unshift({ code: 'header', label: value.name })
              }
            } else if (Object.prototype.hasOwnProperty.call(data, value.header)) {
              data[value.header].push({ code: value.id, label: value.name })
            } else if (!Object.prototype.hasOwnProperty.call(data, value.header)) {
              data[value.header] = [{ code: value.id, label: value.name }]
            }

            if (index + 1 === response.data.length) {
              console.log(data)
              Object.keys(data).map(action => {
                noteActions.push(...data[action])
              })
            }
          })
          store.commit('noteActions', noteActions)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createHiveNote (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/hives/notes/`, info)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editHiveNote (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/hives/notes/${  info.id}`, info.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteHiveNote (store, id) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/hives/notes/${  id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
